import React, { useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const HomeScreen = ({ backgroundImage, withoutTg }) => {
  const [currentTobacco, setCurrentTobacco] = useState(0);
  const [rotation, setRotation] = useState(0);

  const tobaccoData = [
    {
      title: 'Вірджинія',
      items: [
        'найпопулярніший вид тютюну;',
        'визріває в опалювальних коморах;',
        'завдяки теплу листя набуває яскравого кольору та виразного аромату;',
        "має м'який смак і м'яку міцність."
      ]
    },
    {
      title: 'Орієнтал',
      items: [
        'любить денне світло;',
        'листя витримують просто неба близько двох тижнів;',
        'м’який завдяки дії сонячного світла;',
        'цінується у світі за свій делікатний смак.'
      ]
    },
    {
      title: 'Берлі',
      items: [
        'виростає до півтора метра (приблизно як холодильник середнього розміру);',
        'має міцний характер і смак;',
        'сушиться у відкритих коморах, щоб зберегти глибину смаку та аромату.'
      ]
    }
  ];

  const handleWheelClick = () => {
    const nextTobacco = (currentTobacco + 1) % 3;
    const newRotation = rotation + 120;

    setCurrentTobacco(nextTobacco);
    setRotation(newRotation);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content} style={{ backgroundImage }}>
        <img
          className={styles.headGif}
          src={getImageFromS3('images/brand-ed-prl1/tobacco.gif')}
          alt="tobacco-gif"
        />
        <svg
          width="76"
          height="76"
          viewBox="0 0 76 76"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginTop: '-45px' }}
        >
          <rect width="76" height="76" rx="38" fill="#182F5F" />
          <path
            d="M22.5092 34.5211C22.5092 26.6243 25.6632 19.6941 29.147 14.7512C30.8903 12.2778 32.7277 10.2847 34.3193 8.90218C35.1141 8.2117 35.8593 7.66357 36.5106 7.28344C37.1313 6.92119 37.7681 6.65041 38.3174 6.65039C38.862 6.65039 39.4893 6.91033 40.1015 7.26161C40.7421 7.62916 41.4717 8.15934 42.2492 8.82661C43.8061 10.1628 45.6015 12.0893 47.3157 14.4829C50.7417 19.2666 53.8902 25.9817 54.1126 33.6659C54.1242 34.0657 53.8097 34.3994 53.4099 34.4111C53.01 34.4226 52.6763 34.1078 52.6648 33.7079C52.453 26.3897 49.4479 19.9487 46.1378 15.3267C44.4841 13.0176 42.7657 11.1788 41.3055 9.92564C40.5746 9.29832 39.9198 8.8276 39.3803 8.51806C38.8125 8.19224 38.4638 8.09869 38.3174 8.09869C38.1756 8.09872 37.8226 8.19477 37.2406 8.53443C36.6892 8.85627 36.0184 9.34536 35.2697 9.99574C33.7739 11.2951 32.0129 13.1991 30.3308 15.5857C26.9635 20.3633 23.9575 27.0069 23.9575 34.5211C23.9575 44.7666 28.4664 53.312 32.8689 57.7437C33.1508 58.0275 33.1493 58.4861 32.8655 58.768C32.5817 59.0498 32.1231 59.0484 31.8412 58.7647C27.1821 54.0746 22.5092 45.1671 22.5092 34.5211Z"
            fill="white"
          />
          <path
            d="M57.2352 34.8492C59.3106 34.7312 61.1715 34.8687 62.6032 35.1364C63.3177 35.27 63.9403 35.4389 64.436 35.6321C64.8986 35.8125 65.3629 36.0559 65.6358 36.3999C65.9085 36.7439 66.0401 37.2513 66.1106 37.7429C66.186 38.2695 66.2084 38.9143 66.1761 39.6403C66.1112 41.0951 65.8226 42.9378 65.2361 44.9315C64.1013 48.7895 61.8291 53.287 57.8137 56.6387L57.42 56.9594C53.174 60.3292 48.3521 61.9073 44.308 62.298C42.2866 62.4933 40.439 62.3939 38.9389 62.0604C37.469 61.7336 36.2155 61.1553 35.528 60.2905L35.5276 60.2897C34.8413 59.4245 34.5628 58.0728 34.5784 56.5678C34.5944 55.0316 34.9173 53.2103 35.5666 51.2863C36.8657 47.4373 39.4975 43.0999 43.7434 39.7302C48.005 36.3464 53.0897 35.0849 57.2352 34.8492ZM62.3366 36.5607C61.0296 36.3164 59.2867 36.1834 57.3175 36.2954C53.374 36.5196 48.6061 37.7191 44.6443 40.8649C40.641 44.0421 38.1594 48.1347 36.9394 51.7494C36.3292 53.5572 36.0413 55.2264 36.0272 56.5829C36.0127 57.9703 36.2852 58.9137 36.6627 59.3896C37.0417 59.8657 37.8991 60.345 39.2533 60.6461C40.578 60.9406 42.2693 61.0395 44.1687 60.856C47.9665 60.4891 52.5162 59.0019 56.5195 55.8247C60.4813 52.681 62.7318 48.311 63.8462 44.5226C64.4027 42.6308 64.6698 40.9037 64.729 39.5757C64.7587 38.9105 64.7356 38.3604 64.6765 37.9481C64.647 37.7422 64.6101 37.5825 64.572 37.4658C64.532 37.3434 64.5006 37.3 64.5006 37.3C64.4978 37.2968 64.4613 37.2573 64.3558 37.1934C64.2509 37.1297 64.1038 37.0574 63.91 36.9818C63.5219 36.8305 62.9913 36.6831 62.3366 36.5607Z"
            fill="white"
          />
          <path
            d="M14.7526 40.9181C16.5886 40.7495 18.9521 40.821 21.4244 41.3807C21.8145 41.4691 22.0592 41.8571 21.9709 42.2472C21.8826 42.6374 21.4946 42.8821 21.1045 42.7938C18.7925 42.2703 16.5822 42.2046 14.8848 42.3605C14.0354 42.4386 13.3296 42.5707 12.8131 42.7212C12.5542 42.7966 12.3564 42.8728 12.2174 42.9415C12.1068 42.9963 12.0615 43.0325 12.052 43.0398C12.0417 43.0632 11.9901 43.1777 11.9492 43.4516C11.904 43.7538 11.8854 44.1645 11.9084 44.6682C11.9545 45.6731 12.1645 46.9866 12.6049 48.4287C13.4868 51.3163 15.2686 54.6442 18.4031 57.0387H18.4027C23.2393 60.7241 29.0475 61.4162 32.2043 60.7035C32.5945 60.6154 32.9822 60.8603 33.0703 61.2505C33.1584 61.6407 32.9136 62.0285 32.5234 62.1166C28.9399 62.9256 22.6946 62.1308 17.524 58.1906L17.5236 58.1898C14.0855 55.5634 12.1635 51.9427 11.2196 48.8519C10.747 47.3047 10.5135 45.8713 10.4614 44.7345C10.4354 44.1674 10.4539 43.6584 10.5168 43.2375C10.5746 42.851 10.6854 42.4194 10.9341 42.1171H10.9345C11.1088 41.9045 11.3522 41.7533 11.5747 41.6431C11.8123 41.5255 12.0954 41.4214 12.408 41.3304C13.0344 41.1479 13.8353 41.0024 14.7526 40.9181ZM12.0529 43.0377L12.0524 43.0385C12.0532 43.0376 12.0542 43.0362 12.0554 43.0347L12.0529 43.0377Z"
            fill="white"
          />
          <path
            d="M37.5934 42.5675V16.4273C37.5934 16.0272 37.9175 15.7031 38.3176 15.7031C38.7176 15.7031 39.0417 16.0272 39.0417 16.4273V42.5675C39.0417 42.9676 38.7176 43.2921 38.3176 43.2921C37.9175 43.2921 37.5934 42.9676 37.5934 42.5675Z"
            fill="white"
          />
          <path
            d="M43.8362 21.9465C44.1191 21.6637 44.5781 21.6637 44.861 21.9465C45.1437 22.2294 45.1437 22.688 44.861 22.9708L38.8298 29.002C38.5469 29.2849 38.0883 29.2848 37.8055 29.002L31.7743 22.9708C31.4914 22.688 31.4914 22.2294 31.7743 21.9465C32.0571 21.6637 32.5157 21.6637 32.7986 21.9465L38.3172 27.4652L43.8362 21.9465Z"
            fill="white"
          />
          <path
            d="M45.8483 30.9954C46.1312 30.7125 46.5897 30.7125 46.8726 30.9954C47.1555 31.2782 47.1555 31.7368 46.8726 32.0197L38.8297 40.0625C38.5469 40.3454 38.0883 40.3454 37.8054 40.0625L29.7626 32.0197C29.4797 31.7368 29.4797 31.2782 29.7626 30.9954C30.0454 30.7125 30.504 30.7125 30.7869 30.9954L38.3176 38.5261L45.8483 30.9954Z"
            fill="white"
          />
          <path
            d="M29.7626 42.0559C30.0454 41.773 30.504 41.773 30.7869 42.0559L35.7262 46.9952C36.009 47.2781 36.009 47.7367 35.7262 48.0195C35.4434 48.3024 34.9848 48.3023 34.7019 48.0195L29.7626 43.0802C29.4797 42.7973 29.4797 42.3388 29.7626 42.0559Z"
            fill="white"
          />
          <path
            d="M57.9836 41.9952C58.3 41.7505 58.7552 41.8085 58.9999 42.1249C59.2447 42.4413 59.1862 42.8965 58.8698 43.1412L36.5383 60.4133C36.2219 60.658 35.7668 60.6 35.522 60.2836C35.2773 59.9672 35.3353 59.512 35.6517 59.2673L57.9836 41.9952Z"
            fill="white"
          />
          <path
            d="M50.6918 41.3699C50.798 40.9843 51.1965 40.7579 51.5822 40.8641C51.9678 40.9703 52.1942 41.3688 52.088 41.7545L50.0583 49.1227L57.4954 49.8905C57.8932 49.9316 58.1825 50.2874 58.1415 50.6852C58.1004 51.0831 57.7446 51.3726 57.3468 51.3317L49.0588 50.4761C48.8469 50.4543 48.6555 50.3401 48.5353 50.1642C48.4151 49.9884 48.3784 49.7685 48.4349 49.5631L50.6918 41.3699Z"
            fill="white"
          />
          <path
            d="M42.6407 47.4377C42.729 47.0475 43.117 46.8027 43.5071 46.8911C43.8973 46.9795 44.142 47.3674 44.0537 47.7575L42.4069 55.0272L49.4699 55.928C49.8666 55.9787 50.1472 56.3411 50.0967 56.7378C50.0461 57.1346 49.6833 57.4156 49.2865 57.365L41.4329 56.3634C41.2304 56.3375 41.0479 56.2275 40.9309 56.0603C40.8138 55.893 40.7728 55.6839 40.8179 55.4847L42.6407 47.4377Z"
            fill="white"
          />
          <path
            d="M15.6142 46.1608C15.8521 45.8392 16.3056 45.7713 16.6272 46.0092L25.8824 52.8569C26.204 53.0949 26.2719 53.5487 26.034 53.8703C25.796 54.1918 25.3421 54.2594 25.0206 54.0214L15.7658 47.1737C15.4442 46.9358 15.3763 46.4823 15.6142 46.1608Z"
            fill="white"
          />
          <path
            d="M22.1919 44.8624C22.5913 44.8405 22.9331 45.1465 22.9551 45.5459L23.2859 51.5771C23.3058 51.94 23.0538 52.2618 22.6965 52.3289L17.3357 53.3348C16.9426 53.4085 16.564 53.1494 16.4903 52.7563C16.4165 52.3631 16.6756 51.9846 17.0687 51.9108L21.8045 51.0221L21.5085 45.6256C21.4866 45.2262 21.7925 44.8844 22.1919 44.8624Z"
            fill="white"
          />
        </svg>
        <div className={styles.titleContainer}>
          <p className={styles.title}>
            <b>Від насіння до Parliament:</b>
            <br />
            види та сушіння тютюну
          </p>
          <p className={styles.welcomeTitle}>
            <b>Вітаємо!</b> Давай розберемось у світі тютюну разом.
          </p>
        </div>
        <div className={styles.trueOrFalseContainer}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
          >
            <mask id="path-1-inside-1_53_515" fill="white">
              <path d="M13.5459 0L27.0919 13.5459L13.5459 27.0918L6.25396e-06 13.5459L13.5459 0Z" />
            </mask>
            <path
              d="M13.5459 27.0918L12.8388 27.799L13.5459 28.5061L14.253 27.799L13.5459 27.0918ZM27.0919 13.5459L26.3847 12.8388L12.8388 26.3847L13.5459 27.0918L14.253 27.799L27.799 14.253L27.0919 13.5459ZM13.5459 27.0918L14.253 26.3847L0.707113 12.8388L6.25396e-06 13.5459L-0.707101 14.253L12.8388 27.799L13.5459 27.0918Z"
              fill="white"
              mask="url(#path-1-inside-1_53_515)"
            />
            <mask id="path-3-inside-2_53_515" fill="white">
              <path d="M13.5459 4L21.0459 11.5L13.5459 18.9999L6.04597 11.5L13.5459 4Z" />
            </mask>
            <path
              d="M13.5459 18.9999L12.8388 19.707L13.5459 20.4141L14.253 19.707L13.5459 18.9999ZM21.0459 11.5L20.3388 10.7929L12.8388 18.2928L13.5459 18.9999L14.253 19.707L21.753 12.2071L21.0459 11.5ZM13.5459 18.9999L14.253 18.2928L6.75307 10.7929L6.04597 11.5L5.33886 12.2071L12.8388 19.707L13.5459 18.9999Z"
              fill="white"
              mask="url(#path-3-inside-2_53_515)"
            />
          </svg>
          <div className={styles.trueOrFalseContent}>
            <div className={styles.elementBg} />
            <img
              src={getImageFromS3('images/brand-ed-prl1/trueOrFalse.png')}
              alt="true-or-false"
              className={styles.contentImage}
            />
            <div className={styles.textContainer}>
              <p className={styles.headContainer}>Правда чи брехня</p>
              <p className={styles.text}>
                Найсприятливішими для вирощування тютюну є теплі, сонячні
                регіони.
                <br />
                <br />
                <b>Відповідь наприкінці!</b>
              </p>
            </div>
            <img
              className={styles.groupedShadow}
              src={getImageFromS3('images/brand-ed-prl1/groupedShadow.png')}
              alt="groupedShadow"
            />
          </div>
        </div>
        <div className={styles.sortTobaccoContainer}>
          <img
            className={styles.wheelBg}
            src={getImageFromS3('images/brand-ed-prl1/wheel-bg.png')}
            alt="wheel-bg"
          />
          <img
            className={styles.groupedShadow}
            src={getImageFromS3('images/brand-ed-prl1/groupedShadow.png')}
            alt="groupedShadow"
          />
          <p className={styles.sortTitle}>
            <b>Для сигарет Parliament</b>
            <br /> ми використовуємо
            <br /> три основні види тютюну:
          </p>
          <div className={styles.wheelContainer}>
            <svg
              className={styles.parliamentIcon}
              xmlns="http://www.w3.org/2000/svg"
              width="87"
              height="64"
              viewBox="0 0 87 64"
              fill="none"
              style={{ zIndex: 10 }}
            >
              <g filter="url(#filter0_d_425_108)">
                <path
                  d="M6 0L43.5 22.2147L81 0L43.5 51.1905L6 0Z"
                  fill="#D9D9D9"
                />
              </g>
              <path
                d="M6 0L43.5 22.2008L81 0L43.5 35.7143L6 0Z"
                fill="#B7B7B7"
              />
              <defs>
                <filter
                  id="filter0_d_425_108"
                  x="0"
                  y="0"
                  width="87"
                  height="63.1904"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="6" />
                  <feGaussianBlur stdDeviation="3" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_425_108"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_425_108"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
            <img
              className={styles.wheel}
              src={getImageFromS3('images/brand-ed-prl1/wheel.png')}
              alt="wheel"
              style={{ transform: `rotate(${rotation}deg)` }}
            />
            <svg
              onClick={handleWheelClick}
              style={{ cursor: 'pointer', zIndex: 5 }}
              xmlns="http://www.w3.org/2000/svg"
              width="133"
              height="133"
              viewBox="0 0 133 133"
              fill="none"
              className={styles.wheelButton}
            >
              <circle
                cx="66.5"
                cy="66.5"
                r="66.5"
                fill="url(#paint0_linear_757_101)"
                fillOpacity="0.5"
              />
              <circle
                cx="66.5"
                cy="66.5"
                r="40.5"
                fill="url(#paint1_linear_757_101)"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeDasharray="6 6"
              />
              <path
                d="M58.9694 49.5056C58.8297 50.0364 58.2883 50.3462 57.7599 50.1977C57.2313 50.0491 56.9159 49.4981 57.0557 48.967L57.6256 46.8011C57.7653 46.2703 58.3068 45.9605 58.8351 46.109C59.3638 46.2576 59.6791 46.8086 59.5394 47.3396L58.9694 49.5056ZM51.9358 48.5534C51.6607 48.0728 51.0547 47.9025 50.5823 48.173C50.1098 48.4434 49.9498 49.0522 50.2249 49.5328L52.0509 52.7226C52.326 53.2032 52.932 53.3735 53.4045 53.1031C53.8769 52.8326 54.0369 52.2238 53.7618 51.7433L51.9358 48.5534ZM48.5845 55.4489C48.7233 54.9175 48.4073 54.3667 47.8784 54.2184L45.7259 53.6149C45.1974 53.4668 44.6561 53.7769 44.5166 54.3078C44.377 54.8389 44.6924 55.3899 45.2211 55.5385L47.3732 56.1434C47.9028 56.2923 48.4454 55.9812 48.5845 55.4489ZM79.8308 61.6698C79.6524 61.3186 79.4041 61.0076 79.1016 60.7564C78.7992 60.5053 78.4493 60.3195 78.074 60.2108C77.6987 60.1022 77.3063 60.0731 76.9216 60.1253C76.5369 60.1776 76.1684 60.3101 75.8393 60.5144C75.4452 60.7476 75.0701 61.0118 74.7175 61.3044L74.6297 61.3177C74.1883 61.0121 73.6704 60.841 73.1387 60.825C72.607 60.8091 72.0845 60.949 71.6344 61.2279C71.2845 61.4019 70.9667 61.6338 70.6938 61.9141C70.0588 61.4835 69.309 61.2621 68.5495 61.2808C67.79 61.2996 67.0588 61.5577 66.4584 62.0189C65.8691 62.3415 65.3454 62.7721 64.9139 63.2889L60.6034 55.7588C60.3381 55.3253 59.9905 54.9482 59.5809 54.6498C59.1713 54.3513 58.708 54.1374 58.2181 54.0207C57.7281 53.9039 57.2215 53.8866 56.7277 53.9698C56.234 54.0529 55.7631 54.2349 55.3427 54.505C54.8969 54.7308 54.5016 55.0447 54.1798 55.4283C53.8581 55.8119 53.6164 56.2576 53.469 56.7392C53.3216 57.2208 53.2714 57.7286 53.3214 58.233C53.3713 58.7373 53.5204 59.228 53.76 59.6763L60.6874 71.778L57.7313 70.6652C57.3414 70.4524 56.9136 70.322 56.4742 70.2822C56.0349 70.2423 55.5934 70.2939 55.1773 70.4336C54.3429 70.6695 53.6296 71.2104 53.1751 71.9517C52.9704 72.3062 52.8423 72.7012 52.7992 73.1112C52.756 73.5211 52.7988 73.9369 52.9247 74.3316C53.1588 75.0908 53.6648 75.7382 54.3431 76.1468L62.3916 81.6595L71.1916 85.1157C71.704 85.3169 72.275 85.0625 72.4656 84.548C72.6558 84.0345 72.3951 83.4566 71.8831 83.2571L63.3933 79.9493L55.3829 74.4633C55.1125 74.3084 54.9085 74.0571 54.812 73.7596C54.7691 73.6287 54.7542 73.4906 54.7682 73.3543C54.7822 73.218 54.8249 73.0867 54.8932 72.9691C55.1029 72.6633 55.4139 72.4436 55.7714 72.3486C55.956 72.2866 56.1519 72.2644 56.3467 72.2834C56.5414 72.3024 56.7307 72.3623 56.9023 72.4591L62.9816 74.762C63.7122 75.0388 64.3733 74.2488 63.9825 73.5661L55.4708 58.6969C55.3624 58.4769 55.2988 58.2377 55.2839 57.9937C55.269 57.7496 55.3032 57.5058 55.3842 57.2769C55.4653 57.0479 55.5917 56.8385 55.7557 56.6612C55.9198 56.4839 56.1181 56.3425 56.3389 56.2453C56.5345 56.1041 56.757 56.0047 56.9929 55.953C57.2288 55.9013 57.4734 55.8984 57.7119 55.9444C57.9504 55.9905 58.1779 56.0845 58.3808 56.2209C58.5837 56.3573 58.7578 56.5332 58.8926 56.7382L65.4674 68.2238C65.7425 68.7044 66.3485 68.8747 66.8209 68.6043C67.2933 68.3338 67.4533 67.725 67.1782 67.2445L66.3026 65.7148C65.931 65.0657 66.3176 64.4077 67.4536 63.7574C68.0935 63.3911 69.2372 62.9051 69.7243 63.756L70.6 65.2857C70.8751 65.7663 71.4811 65.9366 71.9535 65.6662C72.4259 65.3957 72.5859 64.7869 72.3108 64.3064L72.2481 64.1967C71.8895 63.5702 71.9698 63.2701 72.5977 62.9107C73.4651 62.4141 74.1721 63.5898 74.2498 63.7255L74.8107 64.7053C75.0858 65.1858 75.6918 65.3562 76.1642 65.0857C76.6367 64.8153 76.7966 64.2065 76.5216 63.7259L75.9916 62.8001L75.985 62.8085L75.9856 62.7897L75.9916 62.8001C76.0054 62.7806 76.584 62.3986 76.8338 62.2556C77.0545 62.1293 77.831 62.0452 78.4337 63.0981C78.7154 63.5029 81.4142 68.3049 82.511 70.2209C83.413 71.7972 84.0405 73.5149 84.3658 75.2982C84.4381 75.7397 84.5022 76.4018 84.5485 76.9565C84.5949 77.5126 85.0778 77.9373 85.6282 77.8958C86.175 77.8545 86.5759 77.3689 86.5112 76.8182C86.47 76.4669 86.4233 76.0926 86.3824 75.8212C86.2486 74.7332 85.9943 73.662 85.6242 72.6277C84.7809 70.5601 83.8078 68.5473 82.7107 66.6016L79.8308 61.6698Z"
                fill="white"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_757_101"
                  x1="66.5"
                  y1="0"
                  x2="66.5"
                  y2="133"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#05366A" />
                  <stop offset="1" stopColor="#081037" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_757_101"
                  x1="66.5"
                  y1="26"
                  x2="66.5"
                  y2="107"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#05366A" />
                  <stop offset="1" stopColor="#081037" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div className={styles.tobaccoTitleContainer}>
            <p className={styles.tobaccoTitle}>
              {tobaccoData[currentTobacco].title}
            </p>
            <ul className={styles.tobaccoList}>
              {tobaccoData[currentTobacco].items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className={styles.furtherContainer}>
          <div className={styles.furtherTextContainer}>
            <p className={styles.furtherTitle}>А що далі?</p>
            <p className={styles.furtherText}>
              Потім листя сортують, нарізають, змішують у бленд і перевіряють
              якість.
              <br />
              <br />В результаті виходить спеціальна тютюнова суміш Parliament.
            </p>
          </div>
        </div>
        <div className={styles.trueOrFalseAnswerContainer}>
          <div className={styles.trueOrFalseAnswerContent}>
            <div className={styles.elementBg} />
            <img
              src={getImageFromS3('images/brand-ed-prl1/trueOrFalseAnswer.png')}
              alt="true-or-false-answer"
              className={styles.contentImage}
            />
            <div className={styles.textContainer}>
              <p className={styles.headContainer}>Правда чи брехня:</p>
              <p className={styles.text}>
                P.S. Пам’ятаєш факт умови для вирощування тютюну?
                <br />
                <br />
                <b>Так от — це правда.</b>
              </p>
            </div>
            <img
              className={styles.groupedShadow}
              src={getImageFromS3('images/brand-ed-prl1/groupedShadow.png')}
              alt="groupedShadow"
            />
          </div>
        </div>
        {!withoutTg && (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <mask id="path-1-inside-1_365_153" fill="white">
                <path d="M13.5459 0L27.0919 13.5459L13.5459 27.0918L6.25396e-06 13.5459L13.5459 0Z" />
              </mask>
              <path
                d="M13.5459 27.0918L12.8388 27.799L13.5459 28.5061L14.253 27.799L13.5459 27.0918ZM27.0919 13.5459L26.3847 12.8388L12.8388 26.3847L13.5459 27.0918L14.253 27.799L27.799 14.253L27.0919 13.5459ZM13.5459 27.0918L14.253 26.3847L0.707113 12.8388L6.25396e-06 13.5459L-0.707101 14.253L12.8388 27.799L13.5459 27.0918Z"
                fill="white"
                mask="url(#path-1-inside-1_365_153)"
              />
              <mask id="path-3-inside-2_365_153" fill="white">
                <path d="M13.5459 4L21.0459 11.5L13.5459 18.9999L6.04597 11.5L13.5459 4Z" />
              </mask>
              <path
                d="M13.5459 18.9999L12.8388 19.707L13.5459 20.4141L14.253 19.707L13.5459 18.9999ZM21.0459 11.5L20.3388 10.7929L12.8388 18.2928L13.5459 18.9999L14.253 19.707L21.753 12.2071L21.0459 11.5ZM13.5459 18.9999L14.253 18.2928L6.75307 10.7929L6.04597 11.5L5.33886 12.2071L12.8388 19.707L13.5459 18.9999Z"
                fill="white"
                mask="url(#path-3-inside-2_365_153)"
              />
            </svg>
            <div className={styles.telegramContainer}>
              <div className={styles.linkContainer}>
                <p className={styles.linkTitle}>
                  Якщо бажаєш закріпити нові знання
                </p>
                <p className={styles.linkDescription}>
                  Пройди короткий квіз в офіційному Телеграм-боті Mr.Philip, отримай
                  свою оцінку та переходь у меню досліджувати різний продуктовий
                  контент!
                </p>
                <div className={styles.button} onClick={() => window.open('https://t.me/pmu_support_bot?start=quiz_tobacco', '_blank')}>
                  <img
                    className={styles.glassButton}
                    src={getImageFromS3('images/brand-ed-prl1/glassButton.png')}
                    alt="glassButton"
                  />
                  Перейти у Telegram
                </div>
              </div>
            </div>
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask id="path-1-inside-1_365_156" fill="white">
                <path d="M13.5459 27.0918L7.39579e-06 13.5459L13.5459 1.52492e-06L27.0919 13.5459L13.5459 27.0918Z" />
              </mask>
              <path
                d="M13.5459 1.52492e-06L14.253 -0.707105L13.5459 -1.41421L12.8388 -0.707105L13.5459 1.52492e-06ZM7.39579e-06 13.5459L0.707114 14.253L14.253 0.707108L13.5459 1.52492e-06L12.8388 -0.707105L-0.707099 12.8388L7.39579e-06 13.5459ZM13.5459 1.52492e-06L12.8388 0.707108L26.3847 14.253L27.0919 13.5459L27.799 12.8388L14.253 -0.707105L13.5459 1.52492e-06Z"
                fill="white"
                mask="url(#path-1-inside-1_365_156)"
              />
              <mask id="path-3-inside-2_365_156" fill="white">
                <path d="M13.5459 23.0918L6.04597 15.5919L13.5459 8.09192L21.0459 15.5919L13.5459 23.0918Z" />
              </mask>
              <path
                d="M13.5459 8.09192L14.253 7.38481L13.5459 6.67771L12.8388 7.38481L13.5459 8.09192ZM6.04597 15.5919L6.75307 16.299L14.253 8.79903L13.5459 8.09192L12.8388 7.38481L5.33886 14.8848L6.04597 15.5919ZM13.5459 8.09192L12.8388 8.79903L20.3388 16.299L21.0459 15.5919L21.753 14.8848L14.253 7.38481L13.5459 8.09192Z"
                fill="white"
                mask="url(#path-3-inside-2_365_156)"
              />
            </svg>
          </>
        )}
      </div>
      <div className={styles.footer}>
        Куріння викликає<br />серйозні<br />захворювання та<br />залежність<br />Дана інформація<br />про продукт<br />надається<br />відповідно<br />до статті 15<br />Закону України<br />«Про захист прав<br /> споживачів»
      </div>
    </div>
  );
};

export default HomeScreen;
